import Graylog from 'components/domain/analytics/Graylog/Graylog';
import { useActiveMember } from 'hooks';
import AnalyticsEvent from 'utils/constants/analytics/analyticsEvent';
import { logError } from 'utils/errorUtils';

export default function useSubscriptionGraylog() {
  const activeMember = useActiveMember();

  function downgradedToFree() {
    try {
      Graylog({
        shortMsg: AnalyticsEvent.subscriptions.DOWNGRADED_TO_FREE,
        logObject: {
          _member_id: activeMember.id,
          _member_position_id: activeMember.positionId,
          _id_1: activeMember.organizationId,
        },
      });
    } catch (error) {
      logError(error as Error);
    }
  }

  function deactivatedAccount(reason: string) {
    try {
      Graylog({
        shortMsg: AnalyticsEvent.subscriptions.DEACTIVATED_ACCOUNT,
        logObject: {
          _member_id: activeMember.id,
          _member_position_id: activeMember.positionId,
          _id_1: activeMember.organizationId,
          _generic_1: reason,
        },
      });
    } catch (error) {
      logError(error as Error);
    }
  }

  function reviewPlans(viewType: string) {
    try {
      Graylog({
        shortMsg: AnalyticsEvent.subscriptions.REVIEW_PLANS,
        logObject: {
          _member_id: activeMember.id,
          _member_position_id: activeMember.positionId,
          _view_type: viewType,
        },
      });
    } catch (error) {
      logError(error as Error);
    }
  }

  function upgradePlan(viewType: string) {
    try {
      Graylog({
        shortMsg: AnalyticsEvent.subscriptions.UPGRADE_PLAN,
        logObject: {
          _member_id: activeMember.id,
          _member_position_id: activeMember.positionId,
          _view_type: viewType,
        },
      });
    } catch (error) {
      logError(error as Error);
    }
  }

  function essentialsSelected() {
    try {
      Graylog({
        shortMsg: AnalyticsEvent.subscriptions.ESSENTIALS_SELECTED,
        logObject: {
          _member_id: activeMember.id,
          _member_position_id: activeMember.positionId,
        },
      });
    } catch (error) {
      logError(error as Error);
    }
  }

  function proReducedSelected() {
    try {
      Graylog({
        shortMsg: AnalyticsEvent.subscriptions.PRO_REDUCED_SELECTED,
        logObject: {
          _member_id: activeMember.id,
          _member_position_id: activeMember.positionId,
        },
      });
    } catch (error) {
      logError(error as Error);
    }
  }

  return { downgradedToFree, deactivatedAccount, reviewPlans, upgradePlan, essentialsSelected, proReducedSelected };
}
